import type { HTMLAttributes, KeyboardEvent, ReactNode } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function Card({ title, action, children, className = "", onClick, onKeyDown, role, tabIndex, ...rest }: CardProps) {
  const clickable = Boolean(onClick);
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);
    if (!event.defaultPrevented && onClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    <div
      className={`card${clickable ? " dashboard-card-clickable" : ""} ${className}`.trim()}
      onClick={onClick}
      onKeyDown={clickable ? handleKeyDown : onKeyDown}
      role={clickable ? "link" : role}
      tabIndex={clickable ? 0 : tabIndex}
      {...rest}
    >
      {(title || action) && (
        <div className="card-header">
          {title ? <h2 className="card-title">{title}</h2> : <span />}
          {action}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
}
